var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ae-radio"},[_c('input',{attrs:{"name":_vm.name,"type":_vm.checkbox ? 'checkbox' : 'radio'},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change')}}}),_c('div',{attrs:{"slot":"right"},slot:"right"},[_c('Check')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }